import type { Job, JobSharedRenderings } from 'src/shared/graphql/generated';

export const getFirstRendering = (job?: Job | JobSharedRenderings) =>
  job?.hiDefRenderings?.at(0);
